"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Typography_1 = require("@material-ui/core/Typography");
exports.default = Typography_1.default;
//# sourceMappingURL=Typography.js.map